module.exports = __webpack_public_path__ + "static/img/6.ddb10fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/eng/6.png
// module id = kFsz
// module chunks = 0